<template>
  <main>
    <slide-show :data="$root.banners"></slide-show>
    <div class="chapters">
      <div class="chapter profile">
        <div class="title">
          <h3>
            <div class="title1">
              <div>集团介绍</div>
              <div class="subtitle">Group Introduction</div>
            </div>
            <span class="triangle"></span>
          </h3>
        </div>
        <div class="content">
          <!-- <img src="../assets/images/index/profile.jpg"> -->
          <img :src="Intro.groupPicture" />
          <div class="context">
            <div class="ident">
              <span></span>
              <span></span>
            </div>
            <div v-html="Intro.groupIntroduce"></div>
            <p style="width:100%;height:2px;"></p>
          </div>
        </div>
      </div>
      <div class="chapter services">
        <div class="wrap">
          <div class="title titleReplace">
            <h3>
              <div class="title1">
                <div>主要服务</div>
                <div class="subtitle">Main services</div>
              </div>
              <span class="triangle"></span>
            </h3>
          </div>
          <div class="goods">
            <button class="switch prev" @click="prev" v-if="productsList.length > 3"></button>
            <div class="swiper" @mouseenter="clearEvent" @mouseleave="setEvent">
              <div class="items">
                <div class="item" v-for="i in products">
                  <!-- <img :src="i.serviePicture" v-image="[i.serviePicture]"> -->
                  <a :href="i.pictureUrl">
                    <img :src="i.serviePicture" />
                  </a>
                </div>
              </div>
            </div>
            <button class="switch next" @click="next" v-if="products.length > 3"></button>
          </div>
        </div>
      </div>

      <!-- <div class="chapter client">
        <div class="title">
          <h3>
            <div class="title1">
              <div>合作客户</div>
              <div class="subtitle">Partner customers</div>
            </div>
            <span class="triangle"></span>
          </h3>
        </div>
        <div>
          <img src="../assets/images/index/partner.png" alt />
        </div>
      </div> -->
    </div>
    <div class="message" @click="contactUs()">
      <div class="msg">
        <img src="../assets/images/index/message.png" alt />
        <div>
          <div class="msgRight">
            <img src="../assets/images/index/pen.png" alt />
            <span>联系我们</span>
          </div>
          <div class="long"></div>
          <div class="short"></div>
        </div>
      </div>
    </div>

    <transition name="fade">
      <div class="loginBox" v-if="messageExpand">
        <div class="box">
          <div class="loginBg"></div>
          <div class="login">
            <h3 @click.stop>
              <div class="title">
                <div>留言板</div>
                <div class="subtitle">Message Board</div>
              </div>

              <span class="triangle"></span>
            </h3>
            <div class="form" @click.stop>
              <dl>
                <dt>
                  <strong>*</strong>
                  {{ lang("message_phone") }}
                </dt>
                <dd>
                  <input v-model.number="message.phone" type="tel" v-int placeholder="请输入您的电话" />
                </dd>
              </dl>
              <dl>
                <dt>
                  <strong>*</strong>
                  {{ lang("message_email") }}
                </dt>
                <dd>
                  <input type="email" v-model="message.email" placeholder="请输入您的邮箱" />
                </dd>
              </dl>
              <dl>
                <dt>
                  <strong>*</strong>
                  {{ lang("message_content") }}
                </dt>
                <dd>
                  <textarea rows="1" ref="message" v-model="message.context" placeholder="请输入您的留言"></textarea>
                </dd>
              </dl>
            </div>
            <button class="submit" @click="submitMessage()" binding="message" :disabled="message.email == '' || message.context == '' || !message.phone">{{ ({ ready: lang('message_submit'), working: '正在提交', success: '提交成功', error: '提交失败' }[apiStatus]) }}</button>
            <button class="close" @click.stop="messageExpand = false"></button>
          </div>
        </div>
      </div>
    </transition>
    <div class="cover" v-if="messageExpand"></div>
    <span is="style">
      body {
      --page-width: {{ pageWidth }}px;
      }
    </span>
  </main>
</template>
<style lang="less" scoped>
@width: 1200px;
@red: #e60012;
@activeColor: #e60012;

.expand {
  text-align: left;
  margin: 0 auto;
  width: 700px;
  margin-top: 10px;

  button {
    border: none;
    color: #e60012;
    background-color: transparent;
    padding: 5px 12px;
    border: 1px solid #e60012;
  }
}

.slide-show {
  z-index: 20;
}

.title {
  width: 1200px;

  h3 {
    text-align: left;
    margin: 0 0 20px 0;
    font-size: 20px;
    font-weight: 400;
    background: url(../assets/images/nav/logo_bg.png) no-repeat left center;
    padding-left: 9px;

    .subtitle {
      font-size: 16px;
      font-family: Roboto;
      font-weight: 900;
      color: #888888;
    }

    .title1 {
      width: 180px;
      display: inline-block;
    }

    .triangle {
      display: inline-block;
      border: 5px solid transparent;
      border-bottom: 5px solid @activeColor;
      border-right: 5px solid @activeColor;
    }
  }
}

.titleReplace {
  h3 {
    background: url(../assets/images/nav/logo_bg1.png) no-repeat left center;
    color: #ffffff;

    .subtitle {
      color: #b2b2b2;
    }
  }
}

.fade-enter-active {
  transition: opacity 0.4s;
}

.fade-leave-active {
  transition: opacity 0.01s;
}

.message {
  position: fixed;
  display: flex;
  width: 160px;
  height: 50px;
  right: 10px;
  bottom: 40px;
  border: none;
  z-index: 200;
  // overflow: hidden;
  // transition: all .4s, z-index 0s, background-color 0s;
  cursor: pointer;

  .msg {
    width: 160px;
    height: 50px;
    display: flex;

    .msgRight {
      position: absolute;

      span {
        font-size: 14px;
        font-weight: 400;
        color: #158bc8;
        display: inline-block;
        transform: rotate(-18deg) translate(8px, -15px);
      }
    }

    .long {
      width: 70px;
      height: 2px;
      background-color: #158bc8;
      transform: rotate(-18deg) translate(8px, 10px);
    }

    .short {
      width: 46px;
      height: 1px;
      background-color: #158bc8;
      transform: rotate(-18deg) translate(8px, 19px);
    }
  }
}

.loginBox {
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 102;
  // will-change: opacity;

  .box {
    position: relative;
    width: 440px;
    height: 580px;
  }

  .loginBg {
    position: absolute;
    top: 23px;
    width: 440px;
    height: 534px;
    z-index: 101;
    background-color: @activeColor;
  }

  .login {
    position: absolute;
    left: 20px;
    width: 400px;
    height: 580px;
    background-color: white;
    padding: 26px 20px;
    border: none;
    overflow: hidden;
    z-index: 102;

    h3 {
      text-align: left;
      margin: 0 0 20px 0;
      font-size: 20px;
      font-weight: 400;
      background: url(../assets/images/nav/logo_bg.png) no-repeat left center;
      padding-left: 9px;

      .subtitle {
        font-size: 16px;
        font-family: Roboto;
        font-weight: 900;
        color: #888888;
      }

      .title {
        width: 151px;
        display: inline-block;
      }

      .triangle {
        display: inline-block;
        border: 5px solid transparent;
        border-bottom: 5px solid @activeColor;
        border-right: 5px solid @activeColor;
      }
    }

    .form {
      margin-bottom: 20px;
      font-size: 16px;
      font-weight: 400;

      strong {
        color: #e60012;
        margin-right: 2px;
      }

      dl {
        margin: 0 0 21px 0;

        dt {
          text-align: left;
          color: #666;
          line-height: 24px;
        }

        dd {
          margin: 0;

          input,
          textarea {
            margin: 0;
            width: 100%;
            border: none;
            border-bottom: 1px solid #ccc;
            padding: 6px;
            resize: none;
            line-height: 24px;
            background: transparent;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
          }

          textarea {
            height: 178px;
          }
        }
      }
    }

    .submit {
      border: none;
      background-color: #e60012;
      color: white;
      height: 40px;
      width: 100%;
      transition: all 0.2s;
      margin-top: 26px;

      &:disabled {
        opacity: 0.3;
      }

      &.error,
      &.success,
      &.working {
        color: white;
        display: flex;
        justify-content: center;

        span {
          flex: none;
          order: 1;
        }

        &:after {
          background-color: transparent;
          border-left: none;
        }

        &:before {
          position: relative;
          order: 2;
          margin-left: 5px;
        }
      }

      &.working {
        &:before {
          border-top-color: white;
        }

        &:after {
          display: none;
        }
      }

      &:hover {
        background-color: #e60012;
        opacity: 0.8;
      }
    }

    .close {
      border: none;
      width: 17px;
      height: 17px;
      position: absolute;
      right: 22px;
      top: 22px;
      background: transparent url(../assets/images/index/close.png) center/auto no-repeat;
    }

    &.expand {
      width: 400px;
      height: 515px;
      background-color: white;
      background-image: none;
      border-radius: 5px;
      top: calc(50% - 200px);
      z-index: 20;
      cursor: default;
      padding: 30px;
      transition: all 0.4s, z-index 0s;
    }
  }
}

.chapters {
  .chapter {
    &.profile {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 40px 0 100px 0;

      .title {
        margin-bottom: 40px;
      }

      .content {
        display: flex;
        position: relative;

        img {
          width: 660px;
          height: 440px;
          object-fit: cover;
        }

        .context {
          position: absolute;
          top: 30px;
          left: 469px;
          flex: 1;
          padding: 63px 30px 0 24px;
          width: 731px;
          height: 380px;
          background-color: #efefef;
          color: #353535;
          font-size: 14px;
          line-height: 24px;
          text-align: left;
          overflow: auto;

          .ident {
            display: flex;
            position: absolute;
            top: 29px;
            left: 25px;

            span {
              width: 48px;
              height: 4px;
              background-color: #353535;

              &:not(:last-child) {
                background-color: @activeColor;
              }
            }
          }
        }
      }
    }

    &.services {
      background-image: url(../assets/images/index/product.png);
      background-repeat: no-repeat;
      background-size: cover;
      background-attachment: fixed;

      .wrap {
        padding-top: 40px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .title {
          margin-bottom: 39px;

          .en {
            color: white;
          }

          .cn {
            color: #c4c3c3;
          }
        }

        .goods {
          // width: @width;
          // background-color: white;
          display: flex;
          align-items: center;
          margin-bottom: 67px;

          .swiper {
            width: @width;
            overflow: hidden;
          }

          .items {
            position: relative;
            display: flex;
            flex-wrap: nowrap;
            padding: 0 15px;
            transition: all 0.5s;

            .item {
              float: left;
              flex-shrink: 0;
              width: calc(@width / 3 - 60px / 3);
              height: 284px;
              overflow: hidden;
              background-color: #f3f3f3;

              &:not(:last-child) {
                margin-right: 15px;
              }

              &:hover {
                img {
                  transform: scale(1.1);
                }
              }

              img {
                transition: all 0.3s;
                width: 100%;
                height: 100%;
                object-fit: cover;
              }
            }
          }
        }
      }
    }

    &.client {
      padding: 70px 0 47px 0;
      display: flex;
      flex-direction: column;
      align-items: center;

      .title {
        margin-bottom: 10px;
      }

      img {
        width: 1200px;
        height: 947px;
        object-fit: cover;
        margin: 0 auto;
      }
    }

    .content {
      width: @width;
    }

    .switch {
      display: inline-block;
      width: 60px;
      height: 60px;
      border: none;
      background-position: calc(50% + 2px) center;
      background-repeat: no-repeat;
      background-color: transparent;
      background-image: url(../assets/images/slideshow/arrow.png);
      // opacity: .3;
      transition: all 0.3s;

      &:hover {
        opacity: 1;
      }

      &.prev {
        transform: rotate(180deg);
      }

      &.next {}
    }
  }
}

.cover {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 100;
}

@media screen and (max-width: 1360px) {
  .title {
    width: 100% !important;
    margin-bottom: 20px !important;
    padding-left: 20px !important;
  }

  .chapters .chapter.profile .content {
    position: relative;
    width: 100%;
    padding: 20px;

    img {
      width: 100%;
      height: auto;
    }

    .context {
      position: absolute;
      left: 40px;
      top: 40px;
      right: 40px;
      bottom: 40px;
      padding: 20px;
      width: auto;
      height: auto;
      opacity: .8;
    }
  }

  .goods {
    position: relative;

    .swiper {
      width: var(--page-width) !important;

      .items {
        .item {
          width: calc(var(--page-width) / 3 - 60px / 3) !important;
          height: calc(0.23666 * var(--page-width)) !important;
        }
      }
    }

    .switch {
      position: absolute;
      top: 0;
      width: 30px;
      height: 100% !important;
      background: url(../assets/images/slideshow/arrow.png) center/20px no-repeat, linear-gradient(to right, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, .5) 100%) center/100% no-repeat !important;
      z-index: 10;
      padding: 0;

      &.prev {
        left: 0;
      }

      &.next {
        right: 0;
      }
    }
  }
}
</style>
<script>
export default {
  data() {
    return {
      messageExpand: false,
      message: {
        // language:'',
        context: "",
        email: "",
        phone: ""
      },
      pageWidth: 0,
      products: [],
      partners: [],
      contact: {},
      expand: false,
      Intro: {},
      allowClick: true,
      swiperLeft: 0,
      productsList: "",
      autoTimer: null,
      // groupId:'',
      apiStatus: "ready"
    };
  },
  name: "home",
  mounted() {
    var that = this;
    this.pageWidth = document.body.clientWidth;
    // var map = new AMap.Map('map', {
    // 	zoom: 15, //级别
    // 	center: [120.275412, 36.320112], //中心点坐标
    // });
    // var marker = new AMap.Marker({
    // 	position: [120.275412, 36.320112]
    // })
    // map.add(marker); //添加到地图
    // var infoWindow = new AMap.InfoWindow({
    // 	anchor: 'top-left',
    // 	content: '青岛市贤俊龙彩印',
    // });
    // infoWindow.open(map, [120.275412, 36.320112]);
    this.getPoducts();
    // this.getPartners();
    if (this.$root.groupId) {
      this.$root.getBanner(1);
    }
    this.getIntro();

    window.onblur = function () {
      that.clearEvent();
    };
    window.onfocus = function () {
      that.setEvent();
    };
    window.onresize = function () {
      that.pageWidth = document.body.clientWidth;
      $(".goods .items").css("transition", "all 0s");
      $(".goods .items").css("transform", "translate3d(0px, 0px, 0px)");
      this.swiperLeft = 0;
    };
  },
  methods: {
    getPoducts() {
      var that = this;
      ajax.call(this, {
        url: "/bloc/serveIntroduce/list/language",
        s(res) {
          that.products = res.data;
          that.productsList = res.data;
          if (res.data.length > 3) {
            that.products = that.products.concat(that.products);
            that.setEvent();
          }
        }
      });
    },
    getIntro() {
      var that = this;
      let language = that.$root.langMode == 0 ? "CN" : "EN";
      ajax.call(this, {
        url: "/bloc/introduce/list/" + language,
        data: {
          language: language
        },
        s(res) {
          that.Intro = res.data;
        }
      });
    },
    contactUs() {
      this.messageExpand = true;
      this.message = {
        // language:'',
        context: "",
        email: "",
        phone: ""
      };
      this.apiStatus = "ready";
    },
    isEmail(s) {
      return /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((.[a-zA-Z0-9_-]{2,3}){1,2})$/.test(
        s
      );
    },
    submitMessage() {
      var that = this;
      if (!that.isEmail(that.message.email)) {
        that.$root.alertAuto = true;
        that.$root.alert.push("邮箱格式不正确！");
        return;
      }
      // that.message.language=that.$root.langMode==0?"CN":"EN"
      ajax.call(this, {
        binding: "message",
        url: "/bloc/board/add",
        type: "post",
        data: that.message,
        s(res) {
          that.messageExpand = false;
          that.apiStatus = "success";
          that.$root.alertAuto = true;
          that.$root.alert.push("留言提交成功！");
        }
      });
    },
    next() {
      if (!this.allowClick) return;
      this.allowClick = false;
      this.clearEvent();
      this.play(-this.swiperItemWidth - 15);
      this.setEvent();
      setTimeout(() => {
        this.allowClick = true;
      }, 500);
    },
    prev() {
      if (!this.allowClick) return;
      this.allowClick = false;
      this.clearEvent();
      this.play(this.swiperItemWidth + 15);
      this.setEvent();
      setTimeout(() => {
        this.allowClick = true;
      }, 500);
    },
    play(index = -(this.swiperItemWidth + 15)) {
      console.log(index);
      if (index > 0) {
        if (this.swiperLeft >= 0) {
          $(".goods .items").css("transition", "all 0s");
          $(".goods .items").css(
            "transform",
            "translate3d(-" + this.productsList.length * (this.swiperItemWidth + 15) + "px, 0px, 0px)"
          );
          this.swiperLeft = -this.productsList.length * (this.swiperItemWidth + 15);
        }
      } else {
        if (this.swiperLeft <= -this.productsList.length * (this.swiperItemWidth + 15)) {
          $(".goods .items").css("transition", "all 0s");
          $(".goods .items").css("transform", "translate3d(0px, 0px, 0px)");
          this.swiperLeft = 0;
        }
      }
      setTimeout(() => {
        this.swiperLeft = this.swiperLeft + index;
        $(".goods .items").css("transition", "all 0.5s");
        $(".goods .items").css(
          "transform",
          "translate3d(" + this.swiperLeft + "px, 0px, 0px)"
        );
      }, 100);
    },
    clearEvent() {
      clearInterval(this.autoTimer);
    },
    setEvent() {
      if (this.productsList.length > 3) {
        this.clearEvent();
        this.autoTimer = setInterval(this.next, 5000);
      }
    }
  },
  computed: {
    swiperItemWidth() {
      return this.pageWidth > 1360 ? 380 : this.pageWidth / 3 - 60 / 3;
    }
  },
  watch: {
    "$root.language"() {
      this.getPoducts();
      // this.getPartners();
      this.getIntro();
    }
  }
};
</script>